import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FoldersService extends BaseService {

  constructor(protected http: HttpClient) { 
    super(http);
  }

  getPermission(folderId?: number): Observable<IPermission[]> {
    let url = 'Admin/GetPermissions';
    if (folderId) {
      url = url+`?FId=${folderId}`;
    }
    return this.get(url, {});
  }

  getRefFolderPermissions(): Observable<IPermissionIn[]> {
    let url = 'Admin/GetRefFolderPermissions';
    return this.get(url, {});
  }

  getRefDasboardPermissions(): Observable<IPermissionIn[]> {
    let url = 'Admin/GetRefDasboardPermissions';
    return this.get(url, {});
  }

  setFolderPermissions(obj: IPermission) {
    let url = 'Admin/SetFolderPermissions';
    return this.post(url, obj);
  }

  createFolder(folderName: string): Observable<any> {
    let url = 'Folders/Set';
    return this.get(url, { name: folderName });
  }

  deleteFolder(ids: number []) {
    let url = 'Folders/Delete';
    return this.post(url, ids);
  }

  renameFolder(folderId: number, folderName: string) {
    let url = `Folders/Rename?folderId=${folderId}&name=${folderName}`;
    return this.post(url, {});
  }

  createReport(folderId: number, title: string) {
    let url = 'Dashboards/CreateByFolder';
    return this.get(url, { folderId: folderId, title: title });
  }

  deleteReport(ids: number []) {
    let url = 'Dashboards/Delete';
    return this.post(url, ids);
  }

  renameReport(dashboardId: number, name: string) {
    let url = `Dashboards/RenameDashboard?dashboardId=${dashboardId}&name=${name}`;
    return this.post(url, {});
  }
}

export interface IPermission {
  folderId: number;
  folderTitle?: string;
  folderPermissions: IDashFoldPermission[];
  dashboardPermissions: IDashboardPermissions[];
}

export interface IDashboardPermissions {
  dashboardId: number;
  dashboardTitle?: string;
  inheritFolderPermissions: boolean;
  dashboardPermissions: IDashFoldPermission[];
}

export interface IDashFoldPermission {
  roleId: string;
  roleName?: string;
  roleDescription?: string;
  permissions: IPermissionIn[];
}

export interface IPermissionIn {
  id: number;
  titleEN: string;
  titleKK?: string;
  titleRU?: string;
  isSelected?: boolean;
}
